import {
  DEEP_DIVE_EDITOR_SAVE_REQUESTED,
  DEEP_DIVE_EDITOR_SAVE_SUCCEEDED,
  DEEP_DIVE_EDITOR_SAVE_FAILED,
  PUBLISH_DEEP_DIVE_FORM_REQUESTED,
  PUBLISH_DEEP_DIVE_FORM_SUCCEEDED,
  PUBLISH_DEEP_DIVE_FORM_FAILED,
  UPDATE_DEEP_DIVE_FORM,
  UPDATE_DEEP_DIVE_FORM_AT,
} from "deepDiveEditor/actions/form";

export const deepDiveStatusInitialState = {
  isSaving: false,
  isPublishing: false,
  isDirty: false,
};

export default function(state = deepDiveStatusInitialState, action) {
  switch (action.type) {
    case UPDATE_DEEP_DIVE_FORM:
    case UPDATE_DEEP_DIVE_FORM_AT:
      return {
        ...state,
        isDirty: true,
      };

    case DEEP_DIVE_EDITOR_SAVE_REQUESTED:
      return {
        ...state,
        isSaving: true,
      };

    case DEEP_DIVE_EDITOR_SAVE_SUCCEEDED:
      return {
        ...state,
        isDirty: false,
        isSaving: false,
      };
    case DEEP_DIVE_EDITOR_SAVE_FAILED:
      return {
        ...state,
        isSaving: false,
      };
    case PUBLISH_DEEP_DIVE_FORM_REQUESTED:
      return {
        ...state,
        isPublishing: true,
      };
    case PUBLISH_DEEP_DIVE_FORM_SUCCEEDED:
    case PUBLISH_DEEP_DIVE_FORM_FAILED:
      return {
        ...state,
        isPublishing: false,
      };
    default:
      return state;
  }
}
